/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import { FC, $Container, $GraphicsBox} from '@gongxigames/framework/core/fragments/BuilderY';

export const $TopPanel: FC = () => {
    return <$Container name='TopPanel'>
        <$GraphicsBox
            responsive={{box: {width: '100%', height: '171px'}}}
            responsiveBoxSize
            boxColor={0x000}
            boxAlpha={0.6}
        />
        <$GraphicsBox
            responsive={{box: {width: '100%', height: '42px'}}}
            responsiveBoxSize
            boxColor={0x000}
            boxAlpha={1}
        />
    </$Container>;
};